
import { Vue, Component, Watch } from 'vue-property-decorator';
import moment, { Moment } from 'moment';
import WorkbenchesService from '@/services/workbenches.service';
import lazyInject from '@/di';
import ShopService from '@/services/shop.service';
import {
  City,
} from '@/common/interface/shop';

@Component({})
export default class GMVWriteOrders extends Vue {
  @lazyInject(WorkbenchesService)
  workbenchesService!: WorkbenchesService;
  @lazyInject(ShopService)
  shopService!: ShopService;

  citys: City[] = [];

  filterForm: any = {
    month: '',
    raw_time_start: '',
    raw_time_end: '',
    city: '',
    shop_name: '',
    poi: '',
    amap_order_id: '',
    order_time_start: '',
    order_time_end: '',
  };
  moment = moment;
  columns = [
    {
      title: '订单号',
      dataIndex: 'order_no',
      key: 'order_no',
      align: 'center',
      width: 200,
    },
    {
      title: '城市',
      dataIndex: 'city',
      key: 'city',
      align: 'center',
      width: 100,
    },
    {
      title: '门店名称',
      dataIndex: 'shop_name',
      key: 'shop_name',
      align: 'center',
      width: 200,
    },
    {
      title: 'POI',
      dataIndex: 'poi',
      key: 'poi',
      align: 'center',
      width: 140,
    },
    {
      title: '品牌',
      dataIndex: 'ka_name',
      key: 'ka_name',
      align: 'center',
      width: 100,
    },
    {
      title: '分类名称',
      dataIndex: 'fcname',
      key: 'fcname',
      align: 'center',
      width: 100,
    },
    {
      title: '二级分类名称',
      dataIndex: 'cname',
      key: 'cname',
      align: 'center',
      width: 140,
    },
    {
      title: '商品类型',
      dataIndex: 'goods_cate',
      key: 'goods_cate',
      align: 'center',
      width: 100,
    },
    {
      title: '核销金额',
      dataIndex: 'amount',
      key: 'amount',
      align: 'center',
      width: 100,
    },
    {
      title: '下单时间',
      dataIndex: 'order_time',
      key: 'order_time',
      align: 'center',
      width: 140,
    },
    {
      title: '核销时间',
      dataIndex: 'create_time',
      key: 'create_time',
      align: 'center',
      width: 140,
    },
  ];

  pagination: any = {
    total: 0,
    pageSize: 10,
    current: 1,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    showSizeChanger: true,
    onShowSizeChange: this.handleSizeChange,
    onChange: this.onchange,
  };

  write_time: any = [];

  order_time: any = [];
  // 指定允许选择的月份（例如：2025-06）
  allowedMonth: any = '2025-02'; // 格式为 YYYY-MM

  old_params: any = '';

  @Watch('$route.query')
  onRouteChange() {
    const { old_params, month, raw_time_end, raw_time_start, order_time_start, order_time_end, city, shop_name, poi, amap_order_id, page, pageSize } = this.$route.query;
    this.old_params = old_params;
    const { id } = this.$route.params;
    this.allowedMonth = month;
    const params: any = {
      user_id: id,
      page: page || 1,
      pageSize: pageSize || 10,
    };
    if (raw_time_end && raw_time_start) {
      params.raw_time_end = raw_time_end;
      params.raw_time_start = raw_time_start;
      this.filterForm.raw_time_start = raw_time_start;
      this.filterForm.raw_time_end = raw_time_end;
      this.write_time = [moment(raw_time_start as string, 'YYYY-MM-DD'), moment(raw_time_end as string, 'YYYY-MM-DD')];
    } else {
      const date = moment(month as string, 'YYYY-MM');
      params.raw_time_start = date.format('YYYY-MM-DD');
      params.raw_time_end = date.endOf('month').format('YYYY-MM-DD');
      this.filterForm.raw_time_start = params.raw_time_start;
      this.filterForm.raw_time_end = params.raw_time_end;
      this.write_time = [moment(params.raw_time_start as string, 'YYYY-MM-DD'), moment(params.raw_time_end as string, 'YYYY-MM-DD')];
    }

    if (order_time_start && order_time_end) {
      params.order_time_start = order_time_start;
      params.order_time_end = order_time_end;
      this.filterForm.order_time_start = order_time_start;
      this.filterForm.order_time_end = order_time_end;
      this.order_time = [moment(order_time_start as string, 'YYYY-MM-DD'), moment(order_time_end as string, 'YYYY-MM-DD')];
    }

    if (city) {
      params.city = city;
      this.filterForm.city = +city;
    }
    if (shop_name) {
      params.shop_name = shop_name;
      this.filterForm.shop_name = shop_name;
    }
    if (poi) {
      params.poi = poi;
      this.filterForm.poi = poi;
    }
    if (amap_order_id) {
      params.amap_order_id = amap_order_id;
      this.filterForm.amap_order_id = amap_order_id;
    }
    this.getlist(params);
  }

  /**
  * 禁用不在指定月份的日期
  */
  disabledDate(current: Moment): boolean {
    if (!current) return false;
    return current.format('YYYY-MM') !== this.allowedMonth;
  }

  async getlist(params: any) {
    const res = await this.workbenchesService.getAdGmvOrderList(params, this.$el);
    this.data = res.list;
    this.pagination.total = res.total;
  }

  onChangeOrderTime(val: any) {
    this.order_time = val;
    if (val.length) {
      this.filterForm.order_time_start = val[0].format('YYYY-MM-DD');
      this.filterForm.order_time_end = val[1].format('YYYY-MM-DD');
    } else {
      this.filterForm.order_time_start = '';
      this.filterForm.order_time_end = '';
    }
  }

  onChangeWriteTime(val: any) {
    this.write_time = val;
    if (val.length) {
      this.filterForm.raw_time_start = val[0].format('YYYY-MM-DD');
      this.filterForm.raw_time_end = val[1].format('YYYY-MM-DD');
    } else {
      this.filterForm.raw_time_start = '';
      this.filterForm.raw_time_end = '';
    }
  }

  data = [];

  refresh() {
    this.search();
  }
  back() {
    this.$router.push({ name: 'workbenches.WriteGMVAmount', query: { ...JSON.parse(this.old_params as string) } });
  }

  search() {
    this.pagination.current = 1;
    this.getQueryParams();
  }

  resetQuery() {
    this.filterForm = {
      raw_time_start: '',
      raw_time_end: '',
      order_time_start: '',
      order_time_end: '',
      city: '',
      shop_name: '',
      poi: '',
      amap_order_id: '',
    };
    this.order_time = [];
    this.write_time = [];
    this.pagination.current = 1;
    this.getQueryParams();
  }

  onchange(page: any, pageSize: any) {
    this.pagination.current = page;
    this.pagination.pageSize = pageSize;
    this.getQueryParams();
  }

  async getCityList() {
    const response = (await this.shopService.getCityList()) as unknown as {
      [key: string]: {
        province: City;
        city: City[];
      };
    };
    if (response) {
      const citys = Object.values(response)
        .map((item) => item.city)
        .reduce((prev, cur) => prev.concat(cur), []);
      this.citys = citys;
    } else {
      this.citys = [];
    }
  }

  regionFilterOption(input: string, option: any) {
    return (
      option.componentOptions.children[0].text
        .toLowerCase()
        .indexOf(input.toLowerCase()) >= 0
    );
  }

  getQueryParams() {
    const { raw_time_start, raw_time_end, order_time_start, order_time_end, city, shop_name, poi, amap_order_id } = this.filterForm;
    const { current, pageSize } = this.pagination;
    const params: any = {
      old_params: this.old_params,
      month: this.allowedMonth,
      page: current,
      page_size: pageSize,
    };
    if (raw_time_start && raw_time_end) {
      params.raw_time_start = raw_time_start;
      params.raw_time_end = raw_time_end;
    }
    if (order_time_start && order_time_end) {
      params.order_time_start = order_time_start;
      params.order_time_end = order_time_end;
    }
    if (city) {
      params.city = city;
    }
    if (shop_name) {
      params.shop_name = shop_name;
    }
    if (poi) {
      params.poi = poi;
    }
    if (amap_order_id) {
      params.amap_order_id = amap_order_id;
    }
    params.timestamp = Math.round(Date.now() / 1000);
    this.$router.push({
      query: params,
    });
  }

  handleSizeChange(page: any, pageSize: any) {
    this.pagination.current = 1;
    this.pagination.pageSize = pageSize;
    this.getQueryParams();
  }

  mounted() {
    this.onRouteChange();
    this.getCityList();
  }
}
